import { Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { OfflineIndicatorComponent } from './shared/components/offline-indicator/offline-indicator.component';
import { ThemeService } from './core/services/theme.service';
import { TranslocoService } from '@jsverse/transloco';

const LANG_KEY = 'alexandr_lang';
const SUPPORTED: readonly string[] = ['es', 'en'];

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, OfflineIndicatorComponent],
})
export class AppComponent {
  private theme     = inject(ThemeService);
  private transloco = inject(TranslocoService);

  constructor() {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved && SUPPORTED.includes(saved)) {
      // User previously chose a language — respect it.
      this.transloco.setActiveLang(saved);
    } else {
      // First launch: pick device language, fall back to 'es'.
      const deviceLang = navigator.language?.split('-')[0]?.toLowerCase() ?? 'es';
      const lang = SUPPORTED.includes(deviceLang) ? deviceLang : 'es';
      this.transloco.setActiveLang(lang);
      localStorage.setItem(LANG_KEY, lang);
    }
  }
}
